import { connect } from 'react-redux';
import { Map, List } from 'immutable';

import decorate from '../../utils/decorate';

import { request as updateBetslip } from '../../modules/betslip/actions/update-betslip';

import { request as addBet } from '../../modules/betslip/actions/add-bet';
import { request as addLeg } from '../../modules/betslip/actions/add-leg';
import { request as addSplitBet } from '../../modules/betslip/actions/add-split-bet';
import { request as removeSplitBet } from '../../modules/betslip/actions/remove-split-bet';
import { request as removeBet } from '../../modules/betslip/actions/remove-bet';
import { request as updateBet } from '../../modules/betslip/actions/update-bet';
import { request as updateLeg, bulkUpdateBets } from '../../modules/betslip/actions/update-leg';

import { request as getPossibleBets } from '../../modules/betslip/actions/get-possible-bets';
import { request as placeBet } from '../../modules/betslip/actions/place-bet';
import { request as offerReferredBetslip , clear as clearOfferReferredBetslip } from '../../modules/betslip/actions/offer-referred-betslip';
import { request as acceptReferredBetslip } from '../../modules/betslip/actions/accept-referred-betslip';
import { request as rejectReferredBetslip } from '../../modules/betslip/actions/reject-referred-betslip';
import { clear as clearReferredBetslip } from '../../modules/betslip/actions/get-referred-betslip';
import * as addMultiple from '../../modules/betslip/actions/add-multiple';
import { request as removeMultiple } from '../../modules/betslip/actions/remove-multiple';
import { request as assignReferredBetslip } from '../../modules/betslip/actions/assign-referred-betslip';

//price ladders per sport
import { request as getSportPriceLadders } from '../../modules/ladders/actions/get-list';

import { request as getSports } from '../../modules/sports/actions/get';
import { request as getMarketTemplatesList } from '../../modules/market-templates/actions/get-list';

import BetSlip from './BetSlip.jsx';

import injectPermissions from '../../utils/permissionsInject';

function mapStateToProps(state, props) {
    return {
        accountId: state.user.getIn([ 'data', 'id' ]),
        currency: state.customers.getIn([ 'list', props.id, 'data', 'currency' ]),
        legs: state.betslip.getIn([ 'legs', props.id ]),
        bets: state.betslip.getIn([ 'bets', props.id ]),
        combinations: state.betslip.getIn([ 'combinations', props.id ]),
        multiples: state.betslip.getIn([ 'multiples', props.id ]),
        errors: state.betslip.getIn([ 'possibleBets', props.id, 'errors' ]),
        betPlacement: state.betslip.getIn([ 'placeBet', props.id ], Map()),
        playableBalance: state.customers.getIn([ 'list', props.id, 'data', 'wallet', 'playableBalance' ]),
        depositLimits: state.customers.getIn([ 'list', props.id, 'data', 'depositLimits' ]),
        offeredBetslip: state.betslip.getIn([ 'offered-betslip', props.id ]),
        possibleBetStatus: state.betslip.getIn([ 'possibleBets', props.id, 'state' ]),
        acceptReferredStatus: state.betslip.getIn([ 'accept-referred-betslip', props.id, 'state' ]),
        acceptReferredData: state.betslip.getIn([ 'accept-referred-betslip', props.id ]),
        rejectReferredStatus: state.betslip.getIn([ 'reject-referred-betslip', props.id, 'state' ]),
        traderAssign: state.betslip.getIn([ 'referred-betslip', props.id, 'assignee' ]),
        betslipUpdated: state.betslip.getIn([ 'betslip-updated', props.id]) === 'FINISHED',
        sportPriceLadders: state.ladders.get('items') || Map(),
        sports: state.sports.get('items') || Map(),
        marketTemplates: state.marketTemplates.get('items') || Map(),
        totalFreebetAmount: state.customers.getIn( [ 'freebetCredits', props.id, 'data', 'totalAmount' ], 0 ),
        competitions: state.competitions.get('items') || Map(),
        bonusEngineFreeBets: state.betslip.getIn([ 'bonusEngineFreeBets', props.id ]) || List()
    };
}

function mapDispatchToProps(dispatch, props) {
    //we ensure that we don`t have any sports loaded
    const getSportsAction = !props.sports.size && getSports;

    //this function dispatches BETSLIP_UPDATED action for every action that changes betslip structure
    function dispatchWithUpdateBetSlip(...actions) {
        dispatch(updateBetslip(props.id));

        //this code extends functionality to dispatch multiple actions
        //actions should be regular redux actions
        if (Array.isArray(actions) && actions.length > 0){
            actions.forEach( action => action && dispatch(action));
        }
    }

    return {
        onRemove: (betIndex) => dispatchWithUpdateBetSlip(removeBet(props.id, betIndex)),
        onBetChange: (bet, values) => dispatchWithUpdateBetSlip(updateBet(props.id, bet.get('uid'), values)),
        onLegChange: (legUid, values) => dispatchWithUpdateBetSlip(updateLeg(props.id, legUid, values)),
        onCreateEmptyLeg: () => {
            dispatchWithUpdateBetSlip(
                addLeg(props.id, {
                    type: 'empty',
                    eventName: '',
                    selectionName: '',
                    sport: '',
                    marketType: '',
                    price: '',
                    stakePerLine: 0,
                    isMarketSp: false,
                    priceType: 'fp'
                }),
                getSportsAction && getSportsAction()
            );
        },
        onAddCombinedBet: (combination, legs, stakePerLine, priceType) => {
            const bet = {
                type: combination.get('type'),
                name: combination.get('name'),
                numLines: combination.get('numLines'),
                ewOffered: combination.get('ewOffered'),
                stakePerLine: Number(stakePerLine) || 0,
                price: combination.get('price'),
                eachWay: combination.get('eachWay'),
                legs,
                freeBets: combination.get('freeBets'),
                priceType: priceType
            };

            dispatchWithUpdateBetSlip(addBet(props.id, bet));
        },
        bulkUpdateSelections: stake => dispatch( bulkUpdateBets( props.id, stake ) ),
        onGetMarketTemplatesList: (sportId) => dispatch(getMarketTemplatesList(sportId)),
        onGetPossibleBetsRequest: (bets, selectedLegs, channel, isFreeBet, selectedFreeBets) => {
            dispatch(getPossibleBets(props.id, bets, selectedLegs, channel, isFreeBet, selectedFreeBets));
        },
        onPlaceBetRequest: (bets, channel, override, isFreeBet, selectedFreeBets) => {
            dispatch(placeBet(props.id, bets, channel, override, isFreeBet, selectedFreeBets));
        },
        onOfferReferredBetslip: (bets, channel) => {
            dispatch(offerReferredBetslip(props.id, bets, channel));
        },
        onAssignTrader: () => dispatch(assignReferredBetslip(props.id)),
        onRejectReferredBetslip: () => dispatch(rejectReferredBetslip(props.id)),
        onAcceptReferredBetslip: (bets, channel, override) => {
            dispatch(acceptReferredBetslip(props.id, bets, channel, override));
        },
        onAddSplitBet: (bet) => dispatchWithUpdateBetSlip(addSplitBet(props.id, bet)),
        onRemoveSplitBet: (bet) => dispatchWithUpdateBetSlip(removeSplitBet(props.id, bet)),
        onClearReferredBetslip: () => dispatch(clearReferredBetslip(props.id)),
        onClearOfferReferredBetslip: () => dispatch(clearOfferReferredBetslip()),
        onAddMultiple: (multiple, legsIds, channel, isFreeBet, selectedFreeBets) => {
            dispatchWithUpdateBetSlip(addMultiple.request(props.id, multiple, legsIds, channel, isFreeBet, selectedFreeBets));
        },
        onClearMultiple: () => dispatch(addMultiple.clear(props.id)),
        onRemoveMultiple: (type) => dispatchWithUpdateBetSlip(removeMultiple(props.id, type)),
        onGetSportPriceLadders: () => dispatch(getSportPriceLadders())
    };
}

export default decorate(
    connect(injectPermissions(mapStateToProps), mapDispatchToProps),
    BetSlip
);
